import { getFromStorage } from '../components/utils';
import { URL_SERVICIOS } from './UrlWebServis';
import { getToken, getID } from './Usuario';

export function GetData(type){    

    const url_api = URL_SERVICIOS;
    const usuario = getFromStorage("contarsEmpresa");
    const campus = usuario.id_empresa;
    const token = usuario.token;
    const id = usuario.id_usuario;

//    console.log("campus", campus)

    //const token = getToken();
    //const id = getID();

    
    return new Promise((resolve, reject) => {        
        fetch(url_api+type+'/'+id+'/'+token+'/'+campus)   
        .then((response) => response.json())
        .then((responseJson) => {
            resolve(responseJson);
        })
        .catch((error) => {
           reject(error);
        })
    })    
}